import React, { Component, useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import Highlighter from "react-highlight-words";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import MicroModal from "micromodal";
import latinize from "latinize";
import ModalImage from "react-modal-image";
import _ from "lodash";
import { format, sub } from "date-fns";

import {
  sendtypinwebsocket,
  InviteMessagesMonitoring,
  SharedScreen,
  InitialMonitoring as InitialMonitoringOut,
  sendFurtClient,
  changeDisplayByeChat,
} from "../../actions/websocket";
import {
  ShowVisibleDetailsAtd,
  CloseMonitoring,
  RespostasRapidasida,
  SendNextMonitoring,
  addMonitoring,
  senfFileQuickAswMonitoring,
  addMessage,
  InsertUploadMonitoring,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  addMonitoringSimult,
  DetailsAnotationsida as DetailsAnotationsIda,
  InsertAnotations,
  ByeClientMonitoring,
} from "../../actions";
import { Popover, Tooltipp, Topover } from "../../actions/Tippy";

import TimeCounter from "../TimeCounter";
import Details from "../Details";
import ChatSimultComponent from "../ChatSimult";
import TransferClient from "../TransferClient";
import UserPhoto from "../../components/UserPhoto/userphoto";
import TimeCounterMinute from "../TimeCounterMinute";

import SOUNDWAVE from "../../build/images/sound-wave.png";
import WHATSAPPICON from "../../build/images/whatsapp_new.svg";
import FACEBOOKICON from "../../build/images/facebook_new.svg";
import WEBCHATICON from "../../build/images/webchat-new.svg";
import MONITORIAFUTURA from "../../build/images/monitoria-futura.png";
import { ReactComponent as GESTOR } from "../../build/images/gestor.svg";
import TWITTER from "../../build/images/twitter-new.svg";
import MIDIAEMAIL from "../../build/images/email-new.svg";
import MIDIATELEGRAM from "../../build/images/telegram-new.svg";
import GOOGLEGBM from "../../build/images/googlegbm-new.svg";
import LINKEDIN from "../../build/images/linkedin-new.svg";
import INSTAGRAM from "../../build/images/instagram_new.svg";
import DEFAULT from "../../build/images/default.png";
import AVI from "../../build/images/avi-file.png";
import JPG from "../../build/images/jpg-file.png";
import PDF from "../../build/images/pdf-file.png";
import MP3 from "../../build/images/mp3-file.png";
import TEAMS from "../../build/images/channels/teamsMedium.svg";
import { ReactComponent as FALARATENDENTE } from "../../build/images/falar-com-atendente.svg";
import { ReactComponent as SIGILOSA } from "../../build/images/sigilosa.svg";
import { ReactComponent as SUSURRO } from "../../build/images/sussurro.svg";
import { ReactComponent as MONITORAR } from "../../build/images/monitorar.svg";
import { ReactComponent as INTERCALAR } from "../../build/images/intercalar.svg";
import { ReactComponent as LOADING } from "../../build/images/loading.svg";
import { ReactComponent as TRANSFERICON } from "../../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as TRANSFERICON2 } from "../../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../../build/images/icons/byeatendant-client-icon.svg";
import AddAnotationModal from "../../components/modals/NewModals/AddAnotationModal/AddAnotationModal";

const { meses } = require("../../services/data");
const { connection_platform } = require("../../services/api");

var i = 0;
var typingTimer;
var doneTypingInterval = 5000;
var digitando = 0;
var valorInput = "";

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
}

MicroModal.init();

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

export default function MonitoriasV2() {
  const dispatch = useDispatch();
  const Monitoring = useSelector((state) => state.monitoring);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const TimeStatusAgent = useSelector((state) => state.timestatus);
  const Typing = useSelector((state) => state.typing);
  const UsersAgents = useSelector((state) => state.agents);
  const Messages = useSelector((state) => state.messages);
  const InfoUsers = useSelector((state) => state.informationusers);
  const IPCurrent = useSelector((state) => state.ipcurrent);
  const DisplayDetails = useSelector((state) => state.displaydetailsatd);
  const ClientUserMonitors = useSelector((state) => state.clientusermonitors);
  const CriticidadesAnotacoes = useSelector((state) => state.criticalitys);
  const RespostasRapidas = useSelector((state) => state.respostas);
  const DisplayNextGroup = useSelector((state) => state.displaynextgroup);
  const DetailsAnotations = useSelector((state) => state.detailsanotations);
  const ContactId = useSelector((state) => state.atendimento);

  const [fileasw, setFileasw] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [typing, setTyping] = useState([]);
  const [DescAnotacoes, setDescAnotacoes] = useState([]);
  const [respostas, setRespostas] = useState([]);
  const [respostasinicial, setRespostasInicial] = useState([]);
  const [criticidadeSelec, setCriticidadeSelec] = useState("");
  const [iconeCriticidade, setIconeCriticidade] = useState("");
  const [idCriticidadeSelec, setIdCriticidadeSelec] = useState(0);
  const [activeconsulta, setActiveConsulta] = useState(false);
  const [showbuttondetails, setShowButtonDetails] = useState(" active");
  const [SaveSucess2, setSaveSucess2] = useState(false);
  const [scroller, setScroller] = useState(0);
  const [usermonitors, setUserMonitors] = useState([]);
  const [clientmonitoring, setClientMonitoring] = useState(0);
  const [usermonitorsslider, setUserMonitorsSlider] = useState([]);
  const [moreClient, setMoreClient] = useState([]);
  const [arraygeral, setArrayGeral] = useState([]);
  const [critSelec, setCritSelec] = useState("Todos");
  const [iconCrit, setIconCrit] = useState("");
  const [idCrit, setIdCrit] = useState("");
  const [buttonShowCriticits, setButtonShowCriticits] = useState(false);
  const [buttonShowCriticitsIn, setButtonShowCriticitsIn] = useState(false);
  const [detailsAnotations, setDetailsAnotations] = useState([]);
  const [totalAnotations, setTotalAnotations] = useState(0);
  const [buttonLearnMore, setButtonLearnMore] = useState(false);
  const [expandLearn, setExpandLearn] = useState([]);
  const [expandLessCount, setExpandLessCount] = useState(0);
  const [expandMoreCount, setExpandMoreCount] = useState(0);
  const [theaterStart, setTheaterStart] = useState(20);
  const [arrayusermon, setArrayUserMon] = useState([]);
  const [buttonQuickAnswer, setButtonQuickAnswer] = useState(false);
  const [arrowTerm, setArrowTerm] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loaded, setLoaded] = useState(0);
  const [buttonAnotations, setButtonAnotations] = useState(false);
  const [primaryId, setPrimaryId] = useState(null);
  const [idcdr, setIdcdr] = useState("");
  const [numberCliente, setNumberCliente] = useState(0);
  const [nameCliente, setNameCliente] = useState("");
  const [monitorClient, setMonitorClient] = useState([]);
  const [novaMensagem, setNovaMensagem] = useState([]);

  const containermonRef = useRef(null);
  const comentarioAnotacoesRef = useRef(null);
  const dataInit = useRef(null);
  const dataFim = useRef(null);

  // let monitorClient = [];
  let usermon = [];
  let typing_w = "";
  let datatimeinit = Moment().format("YYYY-MM-DD");
  let datatimefim = Moment().format("YYYY-MM-DD");
  let dia = "";
  let auxdia = "";

  const ShowVisibleDetailsAtdIns = (post) => {
    dispatch(ShowVisibleDetailsAtd(post));
  };

  const ByeMonitoring = (post, monitoringsimult) => {
    dispatch(CloseMonitoring(post, monitoringsimult));
  };

  const InsertAnotationsIn = (idcdr, criticidade, comentario, userid) => {
    InsertAnotations(idcdr, criticidade, comentario, userid)(dispatch);
  };

  const ProximoMonitoring = (proximoatd) => {
    SendNextMonitoring(proximoatd)(dispatch);
  };

  const byeclientmonitoring = (cdrid) => {
    dispatch(ByeClientMonitoring(cdrid));
  };

  const ChangeDisplayByeChat = (cdrid, serverid, iduser, infouser) => {
    changeDisplayByeChat(cdrid, serverid, iduser, infouser);
  };

  const ChangeMonitoringUserIn = (monitoring) => {
    dispatch(
      addMonitoring(
        monitoring.userout,
        monitoring.agent,
        monitoring.line,
        monitoring.ramal,
      ),
    );
  };

  const EditTypeMonitoring = (userin, userout, line, ramal) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    InitialMonitoringOut(userin, userout, line, ramal);
  };

  const InitialMonitoringIn = (userin, userout, name, line, ramal) => {
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));

    if (line !== "4") {
      InitialMonitoringOut(userin, userout, line, ramal);
    } else {
      SharedScreen(ramal);
    }
  };

  const RespostasRapidasIda = (userid) => {
    RespostasRapidasida(userid)(dispatch);
  };

  const DetailsAnotationsida = (datainit, datafim, idcriticidade, telefone) => {
    dispatch(DetailsAnotationsIda(datainit, datafim, idcriticidade, telefone));
  };

  const sendtyping = (typing, InfoUsers, ContactId) => {
    if (digitando === 0) {
      sendtypinwebsocket(1, InfoUsers, ContactId);
      digitando = 1;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    } else {
      doneTypingInterval = 5000;
    }

    function doneTyping() {
      digitando = 0;
      sendtypinwebsocket(0, InfoUsers, ContactId);
    }
  };

  const sendFileAswSocket = (
    InfoUsers,
    ContactId,
    path,
    texto,
    makeid,
    line,
  ) => {
    if (path !== "") {
      senfFileQuickAswMonitoring(
        InfoUsers,
        ContactId,
        path,
        texto,
        makeid,
        line,
      );
    }
  };

  const UploadFile = (
    data,
    InfoUsers,
    ContactId,
    caption,
    makeid,
    size,
    line,
  ) => {
    dispatch(
      InsertUploadMonitoring(
        data,
        InfoUsers,
        ContactId,
        caption,
        makeid,
        size,
        line,
      ),
    );
  };

  const InviteMessage = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    line,
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];

    if (message !== "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
        ),
      );
      // dispatch(
      InviteMessagesMonitoring(
        infousers,
        contactid,
        msgsocket,
        author,
        makeid,
        line,
      );
      // );
    }
  };

  const sendImageAsw = (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];

    if (message !== "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia,
        ),
      );
    }
  };

  const renderPopoverPhoto = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  function DisplayQuickAnswer(e) {
    e.preventDefault();
    setButtonQuickAnswer(!buttonQuickAnswer);
    setRespostasInicial(RespostasRapidas.respostas);
    setRespostas(RespostasRapidas.respostas);
  }

  function handleClick() {
    setActiveConsulta(!activeconsulta);
    setSearchText("");
    setExpandLessCount(0);
    setExpandMoreCount(0);
    document.getElementById("simulation_click").click();
  }

  function furtClient(e, infouser, cdrid, iduser) {
    const socket = sendFurtClient(infouser, cdrid, iduser);
    byeclientmonitoring(cdrid);
  }

  const handleKeyUp = (inf) => {
    const elems = document.getElementsByTagName("mark");
    const tam = elems.length;

    if (tam >= arrowTerm + 1) {
      elems[arrowTerm].scrollIntoView(false);
      if (inf === "less") {
        if (arrowTerm !== 0) {
          setArrowTerm(arrowTerm - 1);
          if (expandLessCount !== 1) {
            setExpandLessCount(expandLessCount - 1);
          }
        }
      } else {
        setArrowTerm(arrowTerm + 1);
        if (expandLessCount !== expandMoreCount) {
          setExpandLessCount(expandLessCount + 1);
        }
      }
    } else {
      if (elems[arrowTerm]) {
        setArrowTerm(1);
        elems[1].scrollIntoView(false);
      }
    }
    if (tam === arrowTerm) {
      if (inf === "less") {
        setArrowTerm(arrowTerm - 1);
        setExpandLessCount(expandLessCount - 1);
      }
    }
  };

  const handleselectedFile = (event, infousers, contactid, line) => {
    const filesend = event.target.files[0];
    if (filesend !== undefined) {
      setSelectedFile(filesend);
      setLoaded(0);
      const data = new FormData();
      let namefile = filesend.name;
      const hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      const ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);

      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgsocket.replace(/\s/g, "");
      if (str !== "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        document.getElementById("chat-message").innerHTML = "";
        UploadFile(
          data,
          infousers,
          contactid,
          msgweb,
          makeid(32),
          filesend.size,
          line,
        );
      } else {
        UploadFile(
          data,
          infousers,
          contactid,
          "",
          makeid(32),
          filesend.size,
          line,
        );
      }
    }
    document.getElementById("file-input").value = "";
  };

  const DisplayAnotations = (e) => {
    e.preventDefault();
    setButtonAnotations(!buttonAnotations);
  };

  const scrollDown = () => {
    const container = containermonRef.current;
    if (container && scroller !== container.scrollHeight) {
      container.scrollTop = container.scrollHeight;
      setScroller(container.scrollHeight);
    }
  };

  const HandleDetails = (e, visible) => {
    e.preventDefault();
    // Chama a função ShowVisibleDetailsAtdIns (já convertida via useDispatch)
    ShowVisibleDetailsAtdIns(visible);
  };

  const CloseMonitoringIn = (e, simult, monitoring, monitoringsimult) => {
    e.preventDefault();
    if (monitoringsimult.length > 1) {
      let j = 0;
      if (simult.userout === monitoringsimult[0].userout) {
        j = 1;
      }
      ProximoMonitoring(monitoringsimult[j]);
    }
    ByeMonitoring(simult, monitoringsimult);
    i = 0;
  };

  const ChangeMonitoringClient = (e, id, index) => {
    setClientMonitoring(id);
    i = index;
  };

  const ChangeMonitoringUnique = (e, id, arrayclient) => {
    setClientMonitoring(id);
    const auxindex = arrayclient.findIndex(
      (client) => client.idatendimento === id,
    );
    i = auxindex;
  };

  const ChangeMonitoringClientMore = (e, id, arrayclient) => {
    setClientMonitoring(id);
    setPrimaryId(id);
    const auxindex = arrayclient.findIndex(
      (client) => client.idatendimento === id,
    );
    const filter = arrayclient.filter((client) => client.idatendimento === id);
    setClientMonitoring(id);
    setArrayUserMon(filter);
    i = auxindex;
    document.getElementById("simulation_click").click();
  };

  const ChangeMonitoringUser = (e, monitoring) => {
    if (e.target.className === "card-atend") {
      ChangeMonitoringUserIn(monitoring);
      i = 0;
      setPrimaryId(0);
      setArrayUserMon([]);
    }
  };

  const GetTermText = (event) => {
    const elems = document.getElementsByTagName("mark");
    const tam = elems.length;
    const textValue = event.target.value;
    setSearchText(textValue);
    setArrowTerm(0);
    setExpandMoreCount(tam);
    if (tam === 0) {
      setExpandLessCount(0);
    } else {
      setExpandLessCount(1);
    }
  };

  const SaveAnotation2 = (e, infoatendimento, infouser) => {
    const criticidade = idCriticidadeSelec;
    const comentario = comentarioAnotacoesRef.current
      ? comentarioAnotacoesRef.current.value
      : "";
    let erro = 0;
    const userid = infouser.id;
    if (criticidade === "") erro = 1;
    if (userid === "") erro = 1;
    if (idcdr === "") erro = 1;

    if (erro === 0) {
      setSaveSucess2((prev) => !prev);
      // Chama a função passada por props ou a action via dispatch
      InsertAnotationsIn(idcdr, criticidade, comentario, userid);
      MicroModal.close("modal__anotacoes-adicionar");
      MicroModal.show("modal__anotacoes-salvo");
    }

    if (buttonShowCriticits === true) {
      setButtonShowCriticits((prev) => !prev);
    }
  };

  const ReturnSaveSucess2 = () => {
    document.getElementById("simulation_click").click();
    setSaveSucess2((prev) => !prev);
  };

  const DisplayCriticidade = (
    desccriticidade,
    idcriticidade,
    tipocriticidade,
  ) => {
    setCriticidadeSelec(desccriticidade);
    setIconeCriticidade(tipocriticidade);
    setIdCriticidadeSelec(idcriticidade);
  };

  const ClosePopovers = (e) => {
    document.getElementById("simulation_click").click();
  };

  const ButtonSendMessage = (
    event,
    author,
    InfoUsers,
    ContactId,
    typemsg,
    line,
  ) => {
    event.preventDefault();
    const chatMessageEl = document.getElementById("chat-message");
    if (chatMessageEl) chatMessageEl.disabled = false;
    let msgweb = chatMessageEl ? chatMessageEl.innerText : "";
    let msgsocket = msgweb;
    const infosendfile = fileasw;

    if (fileasw != null && infosendfile[2] !== 1 && infosendfile.length > 0) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      const str = msgweb.replace(/\s/g, "");
      if (str !== "") {
        sendFileAswSocket(
          InfoUsers,
          ContactId,
          infosendfile[0],
          msgweb,
          makeid(32),
          line,
        );
        sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          "Me",
          InfoUsers,
          ContactId,
          1,
        );
      }
    } else {
      const str = msgweb.replace(/\s/g, "");
      if (str !== "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        InviteMessage(
          makeid(32),
          msgweb,
          "Me",
          InfoUsers,
          ContactId,
          typemsg,
          msgsocket,
          line,
        );
      }
    }
    scrollDown();
    if (chatMessageEl) chatMessageEl.innerHTML = "";
  };

  // 8. handleKeyDown e 9. handleKeyPress
  // Essas funções adicionam event listeners ao elemento "chat-message".
  // Obs.: O ideal seria usar onKeyDown/onKeyPress diretamente no elemento.
  const handleKeyDown = (event) => {
    const el = document.getElementById("chat-message");
    if (el) {
      el.addEventListener("keypress", function (e) {
        if (e.keyCode === 13 && !e.shiftKey) {
          e.preventDefault();
          return false;
        }
      });
      el.addEventListener("keydown", function (e) {
        if (e.keyCode === 33) {
          e.preventDefault();
          return false;
        }
      });
    }
  };

  const handleKeyPress = (event) => {
    const el = document.getElementById("chat-message");
    if (el) {
      el.addEventListener("keypress", function (e) {
        if (e.keyCode === 13 && !e.shiftKey) {
          e.preventDefault();
          return false;
        }
      });
      el.addEventListener("keydown", function (e) {
        if (e.keyCode === 33) {
          e.preventDefault();
          return false;
        }
      });
    }
  };

  const filterList = (event, respostasOriginais) => {
    const updatedList = respostasOriginais.filter((item) => {
      const asw = item.qck_asw_keyword;
      let filtro = event.target.value;
      const er = /[^a-z0-9]/gi;
      filtro = filtro.replace(er, "");
      return asw.toLowerCase().search(filtro.toLowerCase()) !== -1;
    });
    setRespostas(updatedList);
  };

  const InsertQuickAnswer = (
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId,
  ) => {
    event.preventDefault();
    const chatMessageEl = document.getElementById("chat-message");
    if (chatMessageEl) chatMessageEl.innerText = texto;
    if (mimetypeid !== 1) {
      const gerarnomearquivo = makeid(32);
      const photo = {
        uri: filepath,
        type: "application/pdf",
        name: gerarnomearquivo + ".pdf",
      };
      const fileencryp = new FormData();
      fileencryp.append("file", gerarnomearquivo + ".pdf");
      const arrayfile = [filepath, texto, mimetypeid];
      setFileasw([]); // Limpa o estado antes de atualizar
      setFileasw(arrayfile);
    } else {
      setFileasw([]);
      if (editable === false) {
        if (chatMessageEl) chatMessageEl.disabled = true;
      } else {
        if (chatMessageEl) {
          chatMessageEl.disabled = false;
          chatMessageEl.focus();
        }
      }
    }
    setButtonQuickAnswer((prev) => !prev);
    const fileInput = document.getElementById("file-input");
    if (fileInput) fileInput.value = "";
  };

  const handleOnChange = (event, InfoUsers, ContactId, line) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      const chatMessageEl = document.getElementById("chat-message");
      let msgweb = chatMessageEl ? chatMessageEl.innerText : "";
      let msgsocket = msgweb;
      const infosendfile = fileasw;

      if (fileasw != null && infosendfile[2] !== 1 && infosendfile.length > 0) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        const str = msgweb.replace(/\s/g, "");
        if (str !== "") {
          sendFileAswSocket(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
            line,
          );
          sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1,
          );
        }
        if (chatMessageEl) chatMessageEl.innerHTML = "";
        scrollDown();
        // sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
      } else {
        const str = msgweb.replace(/\s/g, "");
        if (str !== "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          InviteMessage(
            makeid(32),
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            "0",
            msgsocket,
            line,
          );
          if (chatMessageEl) chatMessageEl.innerHTML = "";
          scrollDown();
          // sendtyping(0, InfoUsers, ContactId);;NÃO MANDAR TYPPINY POR ENQUANTO
        }
      }
    } else {
      // Ex.: sendtyping(1, InfoUsers, ContactId);;NÃO MANDAR TYPPINY POR ENQUANTO
    }
  };

  function InitialMonitoring(
    e,
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
  ) {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          EditTypeMonitoring(userin, userout, line, ramal);
          // InitialMonitoringIn(userin,userout,name,line,ramal)
        }
      } else {
        InitialMonitoringIn(userin, userout, name, line, ramal);
      }
    } else {
      InitialMonitoringIn(userin, userout, name, line, ramal);
    }
  }

  const renderPopover = (e, clients, IPCurrent, usermon, Monitoring) => (
    <div className="context-menu context-menu--dark" id="drop-aba-more">
      <ul className="context-menu__list context-menu__list--more">
        {clients
          .filter((cli) => cli.idatendimento !== primaryId)
          .map((client, index) => (
            <li
              key={index}
              onClick={(e) =>
                ChangeMonitoringClientMore(e, client.idatendimento, arraygeral)
              }
              className={
                parseInt(client.idatendimento) === parseInt(Monitoring.cdrid)
                  ? "aba-more__item em-curso"
                  : "aba-more__item"
              }
              style={{
                display:
                  usermon.idatendimento === client.idatendimento
                    ? "none"
                    : "block",
              }}
            >
              <div className="aba-more__item__title">
                <div className="aba-more__item__title__photo">
                  {(() => {
                    if (client.pathfile === "  " || client.pathfile === " ") {
                      return <img src={DEFAULT} alt="" width="30" />;
                    } else {
                      return (
                        <img
                          src={
                            client.pathfile
                              ? connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                client.pathfile
                              : null
                          }
                          width="30"
                        />
                      );
                    }
                  })()}
                </div>
                <div className="aba-more__item__title__img">
                  {(() => {
                    if (client.idmidia === "5") {
                      return (
                        <img
                          src={WHATSAPPICON}
                          width="10"
                          alt=""
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    } else if (client.idmidia === "6") {
                      return (
                        <img
                          src={FACEBOOKICON}
                          alt=""
                          width="10"
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    } else if (client.idmidia === "2") {
                      return (
                        <img
                          src={WEBCHATICON}
                          alt=""
                          width="10"
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    }
                  })()}
                </div>
                <div className="aba-more__item__title__text">
                  {createJSON(client.cliente)}
                </div>
              </div>
              <div className="aba-more__item__time">
                <div className="criticidade normal">•</div>
                <div className="aba-more__item__time__text">
                  {(() => {
                    var dataatual = Moment().format("YYYY/MM/DD HH:mm:ss");
                    var datatimeatd = Moment(
                      client.recuperationtime,
                      "DD/MM/YYYY HH:mm:ss",
                    ).format("YYYY/MM/DD HH:mm:ss");
                    let time = Moment(dataatual).diff(datatimeatd, "seconds");
                    time = parseInt(time) + Math.round(IPCurrent.difftime);
                    return (
                      <TimeCounterMinute
                        key={client.idatendimento}
                        horario={time}
                      />
                    );
                  })()}
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );

  function ViewAnotations(e, telefone, cliente, cdrid) {
    MicroModal.show("modal__anotacoes-adicionar");
    buttonSearchAnotation(e, telefone);
    setNumberCliente(telefone);
    setNameCliente(cliente);
    setIdcdr(cdrid);
  }

  function ShowCriticitysInsert(e) {
    e.preventDefault();
    setButtonShowCriticitsIn((prev) => !prev);
  }

  function ChangeCriticitys(
    e,
    desccriticidade,
    idcriticidade,
    tipocriticidade,
  ) {
    e.preventDefault();
    setButtonShowCriticitsIn((prev) => !prev);
    setCriticidadeSelec(desccriticidade);
    setIconeCriticidade(tipocriticidade);
    setIdCriticidadeSelec(idcriticidade);
  }

  function buttonSearchAnotation(e, telefone) {
    e.preventDefault();
    let erro = 0;
    // const datainit = dataInit.current.value;
    // const datafim = dataFim.current.value;
    const datainit = format(
      sub(new Date(), {
        months: 1,
      }),
      "yyyy-MM-dd",
    );
    const datafim = format(new Date(), "yyyy-MM-dd");
    const idcriticidade = idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      DetailsAnotationsida(datainit, datafim, idcriticidade, telefone);
    }
  }

  function ShowCriticitys(e) {
    e.preventDefault();
    setButtonShowCriticits((prev) => !prev);
  }

  function SelectCriticitys(
    e,
    desccriticidade,
    idcriticidade,
    tipocriticidade,
  ) {
    setButtonShowCriticits((prev) => !prev);
    setCritSelec(desccriticidade);
    setIconCrit(tipocriticidade);
    setIdCrit(idcriticidade);
  }

  function checkExpandLearn(e, idanot) {
    let checkClick = expandLearn.indexOf(idanot) != -1 ? true : false;

    if (!checkClick) {
      setExpandLearn(expandLearn.concat([idanot]));
    } else {
      setExpandLearn(
        expandLearn.filter(function (val) {
          return val !== idanot;
        }),
      );
    }
  }

  function changeDisplayTransfer(e, cdrid, serverid, usermon) {
    document.getElementById("transfer_teste").click();
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
  }

  const renderPopoverInfo = (
    e,
    number,
    cliente,
    cdrid,
    infouser,
    iduser,
    serverid,
    client,
  ) => (
    <div className="context-menu" id="drop-aba-menu">
      <ul className="context-menu__list">
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            changeDisplayTransfer(event, cdrid, serverid, iduser)
          }
        >
          <TRANSFERICON2 />
          <div className="contact-info__name">Transferir</div>
        </li>

        <li
          onClick={(event) => ViewAnotations(event, number, cliente, cdrid)}
          className="contact-info contact-info--with-action"
        >
          <i className="material-icons">note_add</i>
          <div className="contact-info__name">Anotações</div>
        </li>

        <li
          onClick={handleClick}
          className="contact-info contact-info--with-action"
        >
          <i className="material-icons">search</i>
          <div className="contact-info__name">Pesquisar</div>
        </li>

        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            ChangeDisplayByeChat(cdrid, serverid, iduser, infouser)
          }
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>
      </ul>
    </div>
  );

  useEffect(() => {
    scrollDown();
    let lengthDiv = document.getElementById("chat-wrapper").offsetWidth;
    let theaterCalc = Math.trunc(lengthDiv / 210);
    setTheaterStart(theaterCalc - 1);
  });

  useEffect(() => {
    RespostasRapidasIda(InfoUsers.id);
  }, []);

  useEffect(() => {
    if (DisplayDetails.displaydetailsatd === true) setShowButtonDetails("");
    if (DisplayDetails.displaydetailsatd === false)
      setShowButtonDetails(" active");
    if (DisplayDetails.displaydetailsatd === undefined)
      setShowButtonDetails("");
  }, [DisplayDetails]);

  useEffect(() => {
    if (Monitoring.length !== 0 && ClientUserMonitors.length !== 0) {
      let arrayClientUser = ClientUserMonitors.filter(
        (client) => parseInt(Monitoring.userout) === parseInt(client.monuser),
      );
      let monitorUsers = arrayClientUser.slice(0, theaterStart);
      setMonitorClient(arrayClientUser[i]);
      // monitorClient = arrayClientUser[i];
      // if(monitorUsers != 0){
      let monitorUsersSlider = arrayClientUser.slice(
        theaterStart,
        arrayClientUser.length,
      );
      setArrayGeral(arrayClientUser);
      setUserMonitors(monitorUsers);
      setUserMonitorsSlider(monitorUsersSlider);
      if (arrayClientUser[i])
        setUserMonitorsSlider(
          monitorUsersSlider.filter(
            (client) =>
              parseInt(usermon.idatendimento) !==
              parseInt(client.idatendimento),
          ),
        );
      // }
    } else {
      setMonitorClient([]);
      setUserMonitors([]);
      setUserMonitorsSlider([]);
      setArrayGeral([]);
    }
  }, [Monitoring, ClientUserMonitors]);

  useEffect(() => {
    if (monitorClient) {
      if (monitorClient.length !== 0) {
        if (clientmonitoring === 0) {
          setClientMonitoring(monitorClient.idatendimento);
        } else {
          if (clientmonitoring !== monitorClient.idatendimento) {
            setMonitorClient(arraygeral[i]);
          }
        }
        if (Object.keys(Messages).length > 0) {
          const mensagemNova = Messages[monitorClient.idatendimento];
          if (mensagemNova === undefined) {
            setNovaMensagem([]);
          } else {
            setNovaMensagem(mensagemNova);
          }
        }
      } else {
        setNovaMensagem([]);
      }
    } else {
      setMonitorClient(usermonitors[0]);
    }
  }, [monitorClient, clientmonitoring, Messages]);

  useEffect(() => {
    if (arrayusermon.length === 0) {
      let monitorUsers = arraygeral.slice(0, theaterStart + 1);
      let monitorUsersSlider = arraygeral.slice(
        theaterStart + 1,
        arraygeral.length,
      );
      setUserMonitors(monitorUsers);
      setUserMonitorsSlider(monitorUsersSlider);
      if (monitorClient) {
        setUserMonitorsSlider(
          monitorUsersSlider.filter(
            (simult) => simult.idatendimento !== monitorClient.idatendimento,
          ),
        );
      }
    } else {
      let loadingClient = arraygeral.findIndex(
        (simult, index, array) =>
          simult.idatendimento === arrayusermon[0].idatendimento,
      );
      if (loadingClient === -1) {
        // this.state.arrayusermon = [];
        setArrayUserMon([]);
        // this.state.clientmonitoring = monitorClient.idatendimento;
        setClientMonitoring(monitorClient.idatendimento);
      }
    }
  }, [arrayusermon]);

  useEffect(() => {
    if (Typing.length != 0) {
      const isTyping = Typing;

      isTyping.map((typingtodo) => {
        if (
          typingtodo.typing === "1" &&
          typingtodo.idatendimento === Monitoring.idatendimento
        ) {
          typing_w = (
            <div className="message left" style={{ marginTop: "20px" }}>
              <div className="bubble 1">
                <img
                  src={LOADING}
                  alt=""
                  className="bubble__typing"
                  width="48"
                />
              </div>
            </div>
          );
        }
      });
    }
  }, [Typing]);

  useEffect(() => {
    if (DetailsAnotations.length !== 0) {
      setDetailsAnotations(DetailsAnotations.detailsanotations);
      setTotalAnotations(DetailsAnotations.detailsanotations.length);
    } else {
      setDetailsAnotations([]);
      setTotalAnotations(0);
    }
  }, [DetailsAnotations]);

  useEffect(() => {
    if (CriticidadesAnotacoes.length !== 0) {
      let newDescAnot = CriticidadesAnotacoes.criticalitys;
      setDescAnotacoes(newDescAnot);
      if (idCriticidadeSelec === 0) {
        setIconeCriticidade(newDescAnot[0].class_criticality);
        setCriticidadeSelec(newDescAnot[0].description);
        setIdCriticidadeSelec(newDescAnot[0].id);
      }
    }
  }, [CriticidadesAnotacoes]);

  return (
    <>
      <div id="app">
        <div className="stage">
          <div className="canvas monitorias-canvas" id="chat-wrapper">
            <div id="column2" className="chat-page column split column-chat">
              <div
                className="popover-box block no-margin-bottom"
                id="popover-all-notes"
              >
                <div className="block-header">
                  <h1>
                    Anotações <i className="fas fa-exclamation-circle"></i>
                  </h1>
                  <div className="close">
                    <i className="far fa-times-circle"></i>
                  </div>
                </div>
                <div className="block-content">
                  <div className="column-user-details">
                    <div className="user-name">
                      André Luiz Batista Aureliano{" "}
                    </div>
                    <div className="user-time">
                      <i className="far fa-clock"></i>{" "}
                      <span className="time">00:10:12</span> na fila
                    </div>
                  </div>
                </div>
              </div>
              <div className="chat-wrapper is-visible" style={{ zIndex: 1 }}>
                <div className="atend-list">
                  <div className="monitoria-slider" id="monitoria-base">
                    {MonitoringSimult.map((simult, index) => (
                      <div
                        key={index}
                        className={
                          Monitoring.userout === simult.userout
                            ? "card-atend active"
                            : "card-atend"
                        }
                        onClick={(e) => ChangeMonitoringUser(e, simult)}
                      >
                        <div className="card-atend__title">{simult.agent}</div>
                        <div className="card-atend__actions">
                          <Tooltipp content={"Monitoria por voz"}>
                            <div
                              className={
                                simult.line === "5"
                                  ? "card-atend__actions__item active"
                                  : "card-atend__actions__item"
                              }
                            >
                              <FALARATENDENTE />
                              {simult.line === "5" ? "Monitoria por Voz" : ""}
                            </div>
                          </Tooltipp>
                          <Tooltipp content={"Escuta sigilosa"}>
                            <div
                              onClick={(e) =>
                                InitialMonitoring(
                                  e,
                                  InfoUsers.id,
                                  simult.userout,
                                  simult.agent,
                                  MonitoringSimult,
                                  "1",
                                  simult.ramal,
                                )
                              }
                              className={
                                simult.line === "1"
                                  ? "card-atend__actions__item active"
                                  : "card-atend__actions__item"
                              }
                            >
                              <SIGILOSA />
                              {simult.line === "1" ? "Escuta sigilosa" : ""}
                            </div>
                          </Tooltipp>
                          <Tooltipp content={"Sussurro"}>
                            <div
                              onClick={(e) =>
                                InitialMonitoring(
                                  e,
                                  InfoUsers.id,
                                  simult.userout,
                                  simult.agent,
                                  MonitoringSimult,
                                  "2",
                                  simult.ramal,
                                )
                              }
                              className={
                                simult.line === "2"
                                  ? "card-atend__actions__item active"
                                  : "card-atend__actions__item"
                              }
                            >
                              <SUSURRO />
                              {simult.line === "2" ? "Sussurro" : ""}
                            </div>
                          </Tooltipp>

                          <Tooltipp content={"Intercalar"}>
                            <div
                              onClick={(e) =>
                                InitialMonitoring(
                                  e,
                                  InfoUsers.id,
                                  simult.userout,
                                  simult.agent,
                                  MonitoringSimult,
                                  "3",
                                  simult.ramal,
                                )
                              }
                              className={
                                simult.line === "3"
                                  ? "card-atend__actions__item active"
                                  : "card-atend__actions__item"
                              }
                            >
                              <INTERCALAR />
                              {simult.line === "3" ? "Intercalar" : ""}
                            </div>
                          </Tooltipp>

                          {/* <Tooltipp content={'Monitorar'}>
                          <div className={simult.line === '4' ? 'card-atend__actions__item active':'card-atend__actions__item'}>
                            <MONITORAR/>  
                            {simult.line === '4' ? 'Monitoria de tela':''}                     
                          </div>
                        </Tooltipp> */}
                          <div
                            className="card-atend__close-btn"
                            onClick={(e) =>
                              CloseMonitoringIn(
                                e,
                                simult,
                                Monitoring,
                                MonitoringSimult,
                              )
                            }
                          >
                            <i className="material-icons">close</i>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {(() => {
                  if (
                    (Monitoring.line !== "4" || Monitoring.line !== "5") &&
                    usermonitors.length !== 0
                  ) {
                    return (
                      <div className="aba-content">
                        <div className="aba-content__item">
                          <div className="client-aba">
                            {arrayusermon.map((usermon, index) => {
                              var nameClass = "client-aba__item";
                              if (usermon.idatendimento === clientmonitoring)
                                nameClass = nameClass + " active";
                              if (
                                parseInt(usermon.idatendimento) ===
                                parseInt(Monitoring.cdrid)
                              )
                                nameClass = nameClass + " em-curso";
                              return (
                                <div
                                  key={index}
                                  className={nameClass}
                                  // onClick={(e) =>
                                  //   this.ChangeMonitoringUnique(
                                  //     e,
                                  //     usermon.idatendimento,
                                  //     this.state.arraygeral
                                  //   )
                                  // }
                                >
                                  <Topover
                                    interactive={true}
                                    content={renderPopoverPhoto(
                                      "e",
                                      ipcurrent,
                                      usermon.pathfile,
                                    )}
                                  >
                                    <div className="client-aba__item__img">
                                      {(() => {
                                        if (
                                          usermon.pathfile === "  " ||
                                          usermon.pathfile === " "
                                        ) {
                                          // return <img src={DEFAULT} alt="" />;
                                          return <UserPhoto size="medium" />;
                                        } else {
                                          return (
                                            // <img
                                            //   src={
                                            //     usermon.pathfile
                                            //       ? connection_platform.type_connect +
                                            //         "://" +
                                            //         ipcurrent +
                                            //         usermon.pathfile
                                            //       : null
                                            //   }
                                            // />
                                            <UserPhoto
                                              size="medium"
                                              link={
                                                usermon.pathfile
                                                  ? connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    usermon.pathfile
                                                  : null
                                              }
                                            />
                                          );
                                        }
                                      })()}
                                    </div>
                                  </Topover>
                                  <div
                                    className="client-aba__item__content"
                                    onClick={(e) =>
                                      ChangeMonitoringUnique(
                                        e,
                                        usermon.idatendimento,
                                        arraygeral,
                                      )
                                    }
                                  >
                                    <div className="client-aba__item__title">
                                      <div className="client-aba__item__title__img">
                                        {(() => {
                                          if (usermon.idmidia === "5") {
                                            return (
                                              <img
                                                src={WHATSAPPICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "4") {
                                            return (
                                              <img
                                                src={FACEBOOKICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "2") {
                                            return (
                                              <img
                                                src={WEBCHATICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "3") {
                                            return (
                                              <img
                                                src={MIDIAEMAIL}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "8") {
                                            return (
                                              <img
                                                src={MIDIATELEGRAM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "6") {
                                            return (
                                              <img
                                                src={INSTAGRAM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "9") {
                                            return (
                                              <img
                                                src={TWITTER}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "10") {
                                            return (
                                              <img
                                                src={LINKEDIN}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "11") {
                                            return (
                                              <img
                                                src={GOOGLEGBM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (usermon.idmidia === "15") {
                                            return (
                                              <img
                                                src={TEAMS}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          }
                                        })()}
                                      </div>
                                      <div className="client-aba__item__title__text">
                                        {createJSON(usermon.cliente)}
                                      </div>
                                    </div>
                                    <div className="client-aba__item__time">
                                      <span className="client-aba__item__time__critic">
                                        <div className="criticidade normal">
                                          •
                                        </div>
                                      </span>
                                      <div className="client-aba__item__time__text">
                                        {(() => {
                                          var dataatual = Moment().format(
                                            "YYYY/MM/DD HH:mm:ss",
                                          );
                                          var datatimeatd = Moment(
                                            usermon.recuperationtime,
                                            "DD/MM/YYYY HH:mm:ss",
                                          ).format("YYYY/MM/DD HH:mm:ss");
                                          var time = Moment(dataatual).diff(
                                            datatimeatd,
                                            "seconds",
                                          );
                                          time =
                                            parseInt(time) +
                                            Math.round(IPCurrent.difftime);
                                          return (
                                            <TimeCounterMinute
                                              key={usermon.idatendimento}
                                              horario={time}
                                            />
                                          );
                                        })()}
                                      </div>
                                      <img
                                        className="client-aba__item__time__typing"
                                        src={"build/images/typing.gif"}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="client-aba__item__menu tippy-context-menu"
                                    data-tippy-placement="bottom"
                                    data-template="drop-consultar-encaminhar"
                                  >
                                    <Popover
                                      trigger="click"
                                      interactive={true}
                                      content={renderPopoverInfo(
                                        "e",
                                        usermon.telefone,
                                        usermon.cliente,
                                        usermon.idatendimento,
                                        InfoUsers,
                                        usermon.monuser,
                                        usermon.serverid,
                                        usermon,
                                      )}
                                    >
                                      <i className="material-icons">
                                        more_vert
                                      </i>
                                    </Popover>
                                  </div>

                                  <div className="client-aba__item__details">
                                    {(() => {
                                      let MenuBot = usermon.menubot.split("~¿");
                                      var verifierName = MenuBot[0].split(":");
                                      if (
                                        verifierName[0] === "Nome" ||
                                        verifierName[0] === "NOME"
                                      ) {
                                        MenuBot.shift();
                                      }
                                      return MenuBot.map((bot) => (
                                        <div className="client-aba__item__details__items">
                                          {createJSON(bot)}
                                        </div>
                                      ));
                                    })()}
                                  </div>
                                </div>
                              );
                            })}

                            {usermonitors.map((client, index) => {
                              var nameClass = "client-aba__item";
                              if (client.idatendimento === clientmonitoring)
                                nameClass = nameClass + " active";

                              if (
                                parseInt(client.idatendimento) ===
                                parseInt(Monitoring.cdrid)
                              )
                                nameClass = nameClass + " em-curso";

                              return (
                                <div
                                  key={index}
                                  className={nameClass}
                                  style={{
                                    display:
                                      usermon.idatendimento ===
                                      client.idatendimento
                                        ? "none"
                                        : "flex",
                                  }}
                                >
                                  <Topover
                                    interactive={true}
                                    content={renderPopoverPhoto(
                                      "e",
                                      ipcurrent,
                                      client.pathfile,
                                    )}
                                  >
                                    <div className="client-aba__item__img">
                                      {(() => {
                                        if (
                                          client.pathfile === "  " ||
                                          client.pathfile === " "
                                        ) {
                                          // return <img src={DEFAULT} alt="" />;
                                          return <UserPhoto size="medium" />;
                                        } else {
                                          return (
                                            // <img
                                            //   src={
                                            //     client.pathfile
                                            //       ? connection_platform.type_connect +
                                            //         "://" +
                                            //         ipcurrent +
                                            //         client.pathfile
                                            //       : null
                                            //   }
                                            // />
                                            <UserPhoto
                                              size="medium"
                                              link={
                                                client.pathfile
                                                  ? connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    client.pathfile
                                                  : null
                                              }
                                            />
                                          );
                                        }
                                      })()}
                                    </div>
                                  </Topover>
                                  <div
                                    className="client-aba__item__content"
                                    onClick={(e) =>
                                      ChangeMonitoringClient(
                                        e,
                                        client.idatendimento,
                                        index,
                                      )
                                    }
                                  >
                                    <div className="client-aba__item__title">
                                      <div className="client-aba__item__title__img">
                                        {(() => {
                                          if (client.idmidia === "5") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={WHATSAPPICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "4") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={FACEBOOKICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "2") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={WEBCHATICON}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "3") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={MIDIAEMAIL}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "8") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={MIDIATELEGRAM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "6") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={INSTAGRAM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "9") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={TWITTER}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "10") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={LINKEDIN}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "11") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={GOOGLEGBM}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          } else if (client.idmidia === "15") {
                                            return (
                                              <img
                                                width="19"
                                                height="19"
                                                src={TEAMS}
                                                alt=""
                                                className="user-name__channel-img"
                                              />
                                            );
                                          }
                                        })()}
                                      </div>
                                      <div
                                        className="client-aba__item__title__text"
                                        onClick={(e) =>
                                          ChangeMonitoringClient(
                                            e,
                                            client.idatendimento,
                                            index,
                                          )
                                        }
                                      >
                                        {createJSON(client.cliente)}
                                      </div>
                                    </div>
                                    <div className="client-aba__item__time">
                                      <span className="client-aba__item__time__critic">
                                        <div className="criticidade normal">
                                          •
                                        </div>
                                      </span>
                                      <div className="client-aba__item__time__text">
                                        {(() => {
                                          var dataatual = Moment().format(
                                            "YYYY/MM/DD HH:mm:ss",
                                          );
                                          var datatimeatd = Moment(
                                            client.recuperationtime,
                                            "DD/MM/YYYY HH:mm:ss",
                                          ).format("YYYY/MM/DD HH:mm:ss");
                                          var time = Moment(dataatual).diff(
                                            datatimeatd,
                                            "seconds",
                                          );
                                          time =
                                            parseInt(time) +
                                            Math.round(IPCurrent.difftime);
                                          return (
                                            <TimeCounterMinute
                                              key={client.idatendimento}
                                              horario={time}
                                            />
                                          );
                                        })()}
                                      </div>
                                      <img
                                        className="client-aba__item__time__typing"
                                        src={"build/images/typing.gif"}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="client-aba__item__menu tippy-context-menu"
                                    data-tippy-placement="bottom"
                                    data-template="drop-consultar-encaminhar"
                                  >
                                    <Popover
                                      trigger="click"
                                      interactive={true}
                                      content={renderPopoverInfo(
                                        "e",
                                        client.telefone,
                                        client.cliente,
                                        client.idatendimento,
                                        InfoUsers,
                                        client.monuser,
                                        client.serverid,
                                        client,
                                      )}
                                    >
                                      <i className="material-icons">
                                        more_vert
                                      </i>
                                    </Popover>
                                  </div>
                                  <div className="client-aba__item__details">
                                    {(() => {
                                      let MenuBot = client.menubot.split("~¿");
                                      var verifierName = MenuBot[0].split(":");
                                      if (
                                        verifierName[0] === "Nome" ||
                                        verifierName[0] === "NOME"
                                      ) {
                                        MenuBot.shift();
                                      }
                                      return MenuBot.map((bot) => (
                                        <div className="client-aba__item__details__items">
                                          {createJSON(bot)}
                                        </div>
                                      ));
                                    })()}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {(() => {
                          if (usermonitorsslider.length !== 0) {
                            return (
                              <Popover
                                trigger="click"
                                interactive={true}
                                animation="none"
                                content={renderPopover(
                                  "e",
                                  usermonitorsslider,
                                  IPCurrent,
                                  usermon,
                                  Monitoring,
                                )}
                              >
                                <div
                                  className="aba-content__more tippy-context-menu tippy active"
                                  data-tippy-placement="bottom"
                                  data-template="drop-aba-more"
                                >
                                  <i className="material-icons">list</i>
                                </div>
                              </Popover>
                            );
                          }
                        })()}
                      </div>
                    );
                  }
                })()}
                {(() => {
                  if (Monitoring.line === "4") {
                    return (
                      <div className="stream">
                        <div className="stream__box"></div>
                        <div className="stream__action">
                          <div className="stream__action__bt">
                            <i className="material-icons">zoom_out_map</i>
                          </div>
                        </div>
                        <div
                          id="containermon"
                          // ref="containermon"
                        ></div>
                      </div>
                    );
                  } else if (
                    Monitoring.line === "5" &&
                    usermonitors.length !== 0
                  ) {
                    return (
                      <div className="center">
                        <div className="center__item">
                          <div className="monitoria-voz">
                            <div className="monitoria-voz__wave-box">
                              <img src={SOUNDWAVE} />
                            </div>
                          </div>
                        </div>
                        <div
                          id="containermon"
                          // ref="containermon"
                        ></div>
                      </div>
                    );
                  } else if (usermonitors.length !== 0) {
                    return (
                      <div
                        className="block full-height no-margin-bottom"
                        id="chat"
                      >
                        <TransferClient
                          ClosePopovers={(event) => ClosePopovers()}
                          // atdCurso={this.state.atdCurso}
                        />
                        <div className="block-header">
                          <div className="column-user-details">
                            {/* <div className="user-time">
                                            {
                                              (() => {
                                                  var dataatual = Moment().format('YYYY/MM/DD HH:mm:ss');
                                                  var datatimeatd = Moment(monitorClient.recuperationtime,'DD/MM/YYYY HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                                                  var time = Moment(dataatual).diff(datatimeatd, 'seconds')
                                                  return <> <i className="far fa-clock"></i> <span className="time"><TimeCounter key={monitorClient.idatendimento} horario={time} /> </span></>
                                              })()
                                            }                 
                                          </div> */}
                          </div>
                          <div className="column-actions">
                            {(() => {
                              if (monitorClient.length != 0) {
                                return (
                                  <a
                                    onClick={(event) =>
                                      HandleDetails(event, true)
                                    }
                                    className={"btn inline" + showbuttondetails}
                                    id="user-more-details"
                                  >
                                    {" Ver detalhes >"}
                                  </a>
                                );
                              }
                            })()}
                          </div>
                          <div
                            className={
                              activeconsulta
                                ? "block-header__search-box is-active"
                                : "block-header__search-box"
                            }
                          >
                            <div className="block-header__search-box-nav">
                              <div className="block-header__search-box-content-input">
                                <input
                                  type="text"
                                  autoFocus={true}
                                  onChange={(event) => GetTermText(event)}
                                  placeholder="Pesquisar mensagens..."
                                  className="block-header__search-box-input"
                                />

                                <div className="block-header__search-box-content-count">
                                  {expandLessCount} de {expandMoreCount}
                                </div>
                              </div>

                              <div className="block-header__search-box-content-icon">
                                <a
                                  onClick={(event) => handleKeyUp("less")}
                                  className="block-header__search-box-icon material-icons"
                                >
                                  expand_less
                                </a>
                                <a
                                  onClick={(event) => handleKeyUp("more")}
                                  className="block-header__search-box-icon material-icons"
                                >
                                  expand_more
                                </a>
                              </div>
                              <button
                                onClick={handleClick}
                                className="block-header__search-box-button"
                              >
                                Concluir
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="block-content chat-canvas">
                          <div
                            className="chat-canvas__content"
                            id="containermon"
                            // ref="containermon"
                          >
                            {novaMensagem.map((message, i) => {
                              let buttons = "";
                              if (message.dia != auxdia) {
                                dia = message.dia;
                                auxdia = message.dia;
                              } else {
                                auxdia = message.dia;
                                dia = "";
                              }
                              var positmessage1 = "message right";
                              var positmessage2 = "fav fav--right";

                              if (message.author != "Me") {
                                var positmessage1 = "message left";
                                var positmessage2 = "fav fav--left";
                              }

                              if (message.username === Monitoring.agent) {
                                var positmessage1 = "message right";
                                var positmessage2 = "fav fav--right";
                              }

                              if (message.author === "Gestor") {
                                var positmessage1 = "message gestor";
                                var positmessage2 = "fav fav--left";
                              }

                              // var verifystar = this.state.active;
                              var mensagem_tratada = message.message.replace(
                                /¿/gi,
                                "\n",
                              );
                              if (message.typemsg === "2") {
                                var get_json = message.message.replace(
                                  /§/gi,
                                  "\r\n",
                                );
                                let separadorurlcaption = get_json.split("~¿");
                                let messageSeparada = separadorurlcaption[0]
                                  .replace(/¿¿/gi, "\r\n\r\n")
                                  .replace(/¿/gi, "\r\n");
                                let url = separadorurlcaption[1];
                                let infos = message.options.split("§");
                                let separador = infos[1].split("¿");

                                if (infos[1]) {
                                  buttons = JSON.parse(
                                    infos[1].replace(/(?<!\w)'|'(?!\w)/g, '"'),
                                  );
                                }

                                let responseButton = "";
                                const arrayFind = novaMensagem.find(
                                  (msg) => msg.replyid === message.messageid,
                                );

                                if (arrayFind) {
                                  responseButton = arrayFind.message;
                                }

                                let typeFile = "";
                                let fileObject = "";
                                if (
                                  url &&
                                  url !== "null" &&
                                  url !== "undefined"
                                ) {
                                  let separadorUrl = url.split(".");
                                  if (
                                    Array.isArray(separadorUrl) &&
                                    separadorUrl.length > 0
                                  ) {
                                    let get_name = separadorUrl[0].split("/");
                                    let verificarexistencia = "";
                                    if (
                                      Array.isArray(separadorUrl) &&
                                      separadorUrl.length >= 1 &&
                                      separadorUrl[1]
                                    ) {
                                      switch (separadorUrl[1].toLowerCase()) {
                                        case "jpeg":
                                        case "png":
                                        case "jpg":
                                          typeFile = "image";
                                          break;
                                        case "pdf":
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "txt":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx":
                                          typeFile = "document";
                                          break;
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg":
                                          typeFile = "audio";
                                          break;
                                        case "mp4":
                                          typeFile = "video";
                                          break;
                                        default:
                                          break;
                                      }
                                    }

                                    fileObject = {
                                      name: get_name[get_name.length - 1],
                                      size: "",
                                      type: typeFile,
                                      path_arquivos: url,
                                      extension: separadorUrl[1]
                                        ? separadorUrl[1].toLowerCase()
                                        : "",
                                      id: message.messageid,
                                    };
                                  }
                                }

                                const hasMessageSeparada = !!messageSeparada;
                                if (hasMessageSeparada) {
                                  mensagem_tratada = messageSeparada;
                                }
                              }

                              const hasButtons =
                                !!buttons &&
                                Array.isArray(buttons) &&
                                buttons.length > 0;
                              if (
                                message.author === "Me" &&
                                parseInt(monitorClient.idatendimento) ===
                                  parseInt(message.contactid) &&
                                message.typemsg === "0"
                              )
                                return (
                                  <div key={i} className={positmessage1}>
                                    <div className="time">{dia}</div>
                                    <div className="bubble 2">
                                      <div
                                        className="text"
                                        style={{ whiteSpace: "pre-line" }}
                                      >
                                        <Highlighter
                                          highlightClassName="YourHighlightClass1"
                                          activeIndex="YourHighlightClass1"
                                          activeClassName="YourHighlightClass1"
                                          className="NovClass"
                                          searchWords={searchText
                                            .split(/\s/)
                                            .filter((word) => word)}
                                          textToHighlight={mensagem_tratada}
                                          sanitize={latinize}
                                        />
                                        <span className="text__end-spacing"></span>
                                      </div>
                                      <div className="bubble__info-content">
                                        <div
                                          className={
                                            message.favorite === "true"
                                              ? "fav fav--inside fav--right active"
                                              : "fav fav--inside fav--right"
                                          }
                                        >
                                          {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Monitoring.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                        </div>
                                        <div className="bubble__info-content__time">
                                          {message.datatime}
                                        </div>
                                        {(() => {
                                          if (positmessage1 != "message left") {
                                            if (
                                              message.statusmsg === "error" &&
                                              connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--" +
                                                    message.statusmsg
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    error
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "entregue"
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "visto"
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--visto"
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              !connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done
                                                  </i>
                                                </div>
                                              );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                );
                              else if (
                                parseInt(monitorClient.idatendimento) ===
                                  parseInt(message.contactid) &&
                                message.typemsg === "0"
                              )
                                return (
                                  <div key={i} className={positmessage1}>
                                    <div className="time">{dia}</div>
                                    <div className="bubble 3">
                                      {(() => {
                                        if (
                                          positmessage1 === "message gestor"
                                        ) {
                                          return (
                                            <>
                                              <div className="bubble-user-name">
                                                Gestor: {InfoUsers.username}
                                              </div>
                                              <div className="icon-gestor">
                                                <GESTOR />
                                                Gestor
                                              </div>
                                            </>
                                          );
                                        }
                                      })()}
                                      <div
                                        className="text"
                                        style={{ whiteSpace: "pre-line" }}
                                      >
                                        <Highlighter
                                          highlightClassName="YourHighlightClass"
                                          searchWords={searchText
                                            .split(/\s/)
                                            .filter((word) => word)}
                                          autoEscape={true}
                                          textToHighlight={mensagem_tratada}
                                          sanitize={latinize}
                                        />
                                        <span className="text__end-spacing"></span>
                                      </div>
                                      <div className="bubble__info-content">
                                        <div
                                          className={
                                            message.favorite === "true"
                                              ? "fav fav--inside fav--right active"
                                              : "fav fav--inside fav--right"
                                          }
                                        >
                                          {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorClient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                        </div>
                                        <div className="bubble__info-content__time">
                                          {message.datatime}
                                        </div>
                                        {(() => {
                                          if (positmessage1 != "message left") {
                                            if (
                                              message.statusmsg === "error" &&
                                              connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--" +
                                                    message.statusmsg
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    error
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "entregue"
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "visto"
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--visto"
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              !connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done
                                                  </i>
                                                </div>
                                              );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                );
                              else if (
                                parseInt(monitorClient.idatendimento) ===
                                  parseInt(message.contactid) &&
                                message.typemsg === "2"
                              )
                                return (
                                  <div key={i} className={positmessage1}>
                                    <div className="time">{dia}</div>
                                    <div className="bubble 4">
                                      <div
                                        className="text"
                                        style={{
                                          whiteSpace: "pre-line",
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "5px",
                                        }}
                                      >
                                        <Highlighter
                                          highlightClassName="YourHighlightClass"
                                          searchWords={searchText
                                            .split(/\s/)
                                            .filter((word) => word)}
                                          autoEscape={true}
                                          textToHighlight={mensagem_tratada}
                                        />
                                        {hasButtons && (
                                          <ul
                                            style={{
                                              alignSelf: "flex-start",
                                              width: "100%",
                                            }}
                                          >
                                            {buttons.map((button, index) => {
                                              return (
                                                <li
                                                  key={`butoon-hsm--${index}`}
                                                  style={{
                                                    padding: "10px 0px",
                                                    borderTop:
                                                      "0.5px solid rgba(0, 0, 0, 0.1)",
                                                  }}
                                                >
                                                  {button.text}
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )}
                                        <span className="text__end-spacing"></span>
                                      </div>
                                      <div className="bubble__info-content">
                                        <div
                                          className={
                                            message.favorite === "true"
                                              ? "fav fav--inside fav--right active"
                                              : "fav fav--inside fav--right"
                                          }
                                          style={{ display: "none" }}
                                        >
                                          <i
                                            // onClick={(event) =>
                                            //   markstar2(
                                            //     message.messageid,
                                            //     InfoUsers.id,
                                            //     message.favorite,
                                            //     Monitoring.idatendimento
                                            //   )
                                            // }
                                            className="material-icons fav-icon"
                                          >
                                            {message.favorite === "true"
                                              ? "star"
                                              : "star_border"}
                                          </i>
                                        </div>
                                        <div className="bubble__info-content__time">
                                          {message.data}
                                        </div>
                                        {(() => {
                                          if (positmessage1 != "message left") {
                                            if (
                                              message.statusmsg === "error" &&
                                              connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--" +
                                                    message.statusmsg
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    error
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "entregue"
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              message.statusmsg === "visto"
                                            )
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--visto"
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else if (
                                              !connection_platform.isStatusOfErrorInSendMessage
                                            )
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            else
                                              return (
                                                <div className={"message-info"}>
                                                  <i className="material-icons">
                                                    done
                                                  </i>
                                                </div>
                                              );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                );
                              else if (
                                parseInt(monitorClient.idatendimento) ===
                                  parseInt(message.contactid) &&
                                message.typemsg === "1"
                              ) {
                                var get_json = message.message;
                                let separadorurlcaption = get_json.split("~¿");

                                let thumbnail = separadorurlcaption[0];
                                let caption = separadorurlcaption[1];
                                let size = separadorurlcaption[3];
                                if (caption)
                                  caption = caption.replace(/¿/gi, "\r\n");
                                if (caption == "null") caption = "";

                                let url = separadorurlcaption[2];
                                let separador = url.split(".");
                                let get_name = separador[0].split("/");
                                let verificarexistencia = "";

                                // eslint-disable-next-line default-case

                                if (separador[1] !== undefined) {
                                  switch (separador[1].toLowerCase()) {
                                    case "jpeg":
                                    case "png":
                                    case "jpg":
                                      return (
                                        <div
                                          className={positmessage1}
                                          key={message.id}
                                        >
                                          <div className="time">{dia}</div>
                                          <div className="bubble 5">
                                            <div className="bubble-media">
                                              <div className="bubble-media__image">
                                                <ModalImage
                                                  small={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  large={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  alt={get_name[6]}
                                                  hideDownload={true}
                                                  className="bubble-media__image-file"
                                                />
                                                {/* <img className="bubble-media__image-file" src={connection_platform.type_connect+'://'+ipcurrent+url} alt="" /> */}
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    {get_name[6]}
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {size}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {separador[1].toUpperCase()}
                                                    </span>
                                                  </div>
                                                </span>

                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                            <div className="text">
                                              {caption}
                                            </div>
                                            <div className="bubble__info-content">
                                              <div
                                                className={
                                                  message.favorite === "true"
                                                    ? "fav fav--inside fav--right active"
                                                    : "fav fav--inside fav--right"
                                                }
                                              >
                                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Monitoring.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                              </div>
                                              <div className="bubble__info-content__time">
                                                {message.datatime}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );

                                      break;
                                    case "pdf":
                                      if (
                                        thumbnail === " " ||
                                        thumbnail === null ||
                                        thumbnail === "null"
                                      ) {
                                        verificarexistencia = "";
                                      } else {
                                        verificarexistencia = (
                                          <div className="bubble-media__image">
                                            <ModalImage
                                              small={
                                                connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                thumbnail
                                              }
                                              large={
                                                connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                thumbnail
                                              }
                                              alt={get_name[6]}
                                              hideDownload={true}
                                              className="bubble-media__image-file"
                                            />
                                          </div>
                                        );
                                      }

                                      return (
                                        <div
                                          className={positmessage1}
                                          key={message.id}
                                        >
                                          <div className="time">{dia}</div>
                                          <div className="bubble 6">
                                            <div className="bubble-media">
                                              {verificarexistencia}
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    {get_name[6]}
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {size}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {separador[1].toUpperCase()}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                            <div className="text">
                                              {caption}
                                            </div>
                                            <div className="bubble__info-content">
                                              <div
                                                className={
                                                  message.favorite === "true"
                                                    ? "fav fav--inside fav--right active"
                                                    : "fav fav--inside fav--right"
                                                }
                                              >
                                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorClient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                              </div>
                                              <div className="bubble__info-content__time">
                                                {message.datatime}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                      break;
                                    case "xls":
                                    case "xlsx":
                                    case "doc":
                                    case "docx":
                                    case "ppt":
                                    case "pptx":
                                      return (
                                        <div
                                          className={positmessage1}
                                          key={message.id}
                                        >
                                          <div className="time">{dia}</div>
                                          <div className="bubble 7">
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__image-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    {get_name[6]}
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {size}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {separador[1].toUpperCase()}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                                <div className="bubble__info-content">
                                                  <div
                                                    className={
                                                      message.favorite ===
                                                      "true"
                                                        ? "fav fav--inside fav--right active"
                                                        : "fav fav--inside fav--right"
                                                    }
                                                  >
                                                    {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorClient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                  </div>
                                                  <div className="bubble__info-content__time">
                                                    {message.datatime}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                      break;
                                    case "wav":
                                    case "mp3":
                                    case "ogg":
                                    case "mpeg":
                                      return (
                                        <div
                                          className={positmessage1}
                                          key={message.id}
                                        >
                                          <div className="time">{dia}</div>
                                          <div className="bubble 8">
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    {get_name[6]}
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {size}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {separador[1].toUpperCase()}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                                <div className="bubble__info-content">
                                                  <div
                                                    className={
                                                      message.favorite ===
                                                      "true"
                                                        ? "fav fav--inside fav--right active"
                                                        : "fav fav--inside fav--right"
                                                    }
                                                  >
                                                    {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorClient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                  </div>
                                                  <div className="bubble__info-content__time">
                                                    {message.datatime}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                      break;
                                    case "mp4":
                                      return (
                                        <div
                                          className={positmessage1}
                                          key={message.id}
                                        >
                                          <div className="time">{dia}</div>
                                          <div className="bubble 9">
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    {get_name[6]}
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {size}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {separador[1].toUpperCase()}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                            <div className="text">
                                              {caption}
                                            </div>
                                            <div className="bubble__info-content">
                                              <div
                                                className={
                                                  message.favorite === "true"
                                                    ? "fav fav--inside fav--right active"
                                                    : "fav fav--inside fav--right"
                                                }
                                              >
                                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorClient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                              </div>
                                              <div className="bubble__info-content__time">
                                                {message.datatime}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                      break;
                                  }
                                }
                              }
                            })}
                            {typing_w}
                          </div>
                        </div>
                        <div
                          className="block-footer"
                          style={{
                            display: Monitoring.line === "1" ? "none" : "block",
                          }}
                        >
                          <div className="message-box">
                            <div className="input-message">
                              {(() => {
                                if (Monitoring.line === "2") {
                                  return (
                                    <div className="monitoria-icon">
                                      <SUSURRO />
                                    </div>
                                  );
                                } else if (Monitoring.line === "3") {
                                  return (
                                    <div className="monitoria-icon">
                                      <INTERCALAR />
                                    </div>
                                  );
                                }
                              })()}
                              <div
                                onKeyPress={handleKeyPress}
                                autoComplete="off"
                                type="text"
                                // ref={(node) => (this.node = node)}
                                onInput={(e) =>
                                  (valorInput = e.target.innerText)
                                }
                                onKeyDown={handleKeyDown}
                                onKeyUp={(event) =>
                                  handleOnChange(
                                    event,
                                    InfoUsers,
                                    monitorClient,
                                    Monitoring.line,
                                  )
                                }
                                className="chat-message"
                                id="chat-message"
                                contentEditable="true"
                              ></div>

                              <button
                                type="submit"
                                onClick={(event) =>
                                  ButtonSendMessage(
                                    event,
                                    "Me",
                                    InfoUsers,
                                    monitorClient,
                                    "0",
                                    Monitoring.line,
                                  )
                                }
                                className="send-message"
                              >
                                <i className="material-icons">send</i>
                              </button>
                            </div>
                            <a
                              onClick={(e) => DisplayQuickAnswer(e)}
                              className="btn action with-icon"
                              id="action-premade-messages"
                              data-tippy="Mensagens predefinidas"
                            >
                              <i className="material-icons">
                                chat_bubble_outline
                              </i>
                            </a>
                            <div
                              className={
                                buttonQuickAnswer
                                  ? "premade-msg active"
                                  : "premade-msg"
                              }
                            >
                              <p className="premade-msg__title">
                                Mensagens Predefinidas
                              </p>
                              <div className="premade-msg__content">
                                <ul className="premade-msg__list">
                                  {respostas.map((resp) => (
                                    <li
                                      key={resp.qck_asw_id}
                                      className="premade-msg__item"
                                      onClick={(event) =>
                                        InsertQuickAnswer(
                                          event,
                                          resp.qck_asw_answer,
                                          resp.editable,
                                          resp.mimetypeid,
                                          resp.filepath,
                                          InfoUsers,
                                          monitorClient,
                                        )
                                      }
                                    >
                                      {resp.qck_asw_keyword}
                                    </li>
                                  ))}
                                </ul>
                                <div className="premade-msg__input-wrapper">
                                  <input
                                    type="text"
                                    className="premade-msg__search-input"
                                    onChange={(event) =>
                                      filterList(event, respostasinicial)
                                    }
                                    placeholder="Pesquise uma resposta..."
                                  />
                                  <span className="premade-msg__input-icon">
                                    <i className="material-icons">search</i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <a
                              className="btn action with-icon chat-special tippy-default"
                              data-tippy-theme="light"
                              id="action-attachment"
                              data-tippy-content="Adicionar Anexo"
                            >
                              <label
                                htmlFor="file-input"
                                className="material-icons"
                              >
                                attach_file
                              </label>
                              <input
                                style={{ display: "none" }}
                                type="file"
                                name="upload"
                                id="file-input"
                                onChange={(event) =>
                                  handleselectedFile(
                                    event,
                                    InfoUsers,
                                    monitorClient,
                                    Monitoring.line,
                                  )
                                }
                              />
                            </a>
                            <a
                              className="btn action with-icon chat-special tippy-default"
                              data-tippy-theme="light"
                              id="action-voice"
                              data-tippy-content="Atender em voz"
                            >
                              <i className="material-icons">mic</i>
                            </a>

                            {/* <!-- PREMADE MESSAGES BOX --> */}
                            <div className="premade-msg">
                              <p className="premade-msg__title">
                                Respostas rápidas
                              </p>
                              <div className="premade-msg__content">
                                <ul className="premade-msg__list">
                                  <li className="premade-msg__item">
                                    Estou pesquisando. Por favor aguarde.
                                  </li>
                                  <li className="premade-msg__item">
                                    Um momento, por favor.
                                  </li>
                                  <li className="premade-msg__item">
                                    Já tenho o seu numero de protocolo. Pode
                                    anotar?
                                  </li>
                                  <li className="premade-msg__item">
                                    Um momento, por favor.
                                  </li>
                                </ul>
                                <div className="premade-msg__input-wrapper">
                                  <input
                                    type="text"
                                    className="premade-msg__search-input"
                                    placeholder="Pesquise uma resposta..."
                                  />
                                  <span className="premade-msg__input-icon">
                                    <i className="material-icons">search</i>
                                  </span>
                                </div>
                              </div>
                              {/* <!-- END PREMADE MESSAGES BOX --> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="block full-height no-margin-bottom"
                        id="chat"
                      >
                        <div className="center">
                          <div className="center__item">
                            <div className="monitoria-futura">
                              <div className="monitoria-futura__text">
                                <div className="monitoria-futura__text__title">
                                  Oops...
                                </div>
                                <div className="monitoria-futura__text__bodytext">
                                  <span className="monitoria-futura__text__bodytext__operator">
                                    {Monitoring.agent + " "}
                                  </span>
                                  não está em atendimento agora
                                </div>
                              </div>
                              <img
                                className="monitoria-futura__img"
                                src={MONITORIAFUTURA}
                              />
                            </div>
                            <div
                              id="containermon"
                              // ref="containermon"
                            ></div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>
              <div className="block transparent active-chats" id="active-chats">
                <div className="active-chats__tabs">
                  <ul className="active-chats__list">
                    <ChatSimultComponent
                      chatemcurso={""}
                      remotescreen={"monitorias"}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Modal De Anotacoes */}
        </div>

        {/* Modal de adicionar anotação */}
        <AddAnotationModal selectedChat={monitorClient} />
        {/* <NewAnotationModal /> */}

        <input type="hidden" id="simulation_click" name="simulation_click" />
      </div>
      {(() => {
        if (monitorClient) {
          if (monitorClient.length != 0) {
            return (
              <Details
                displayscreen={"monitoring"}
                monitorclient={monitorClient}
              />
            );
          }
        }
      })()}
    </>
  );
}
